import { apiClient } from './client'
import type { ApiResponse, AuthResponse, LoginRequest, RegisterRequest } from '@/types/api'

export const authApi = {
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<ApiResponse<AuthResponse>>('/auth/login', data)
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error?.message || 'Login failed')
    }
    return response.data.data
  },

  register: async (data: RegisterRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<ApiResponse<AuthResponse>>('/auth/register', data)
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error?.message || 'Registration failed')
    }
    return response.data.data
  },

  refreshToken: async (refreshToken: string): Promise<AuthResponse> => {
    const response = await apiClient.post<ApiResponse<AuthResponse>>('/auth/refresh', { refreshToken })
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.error?.message || 'Token refresh failed')
    }
    return response.data.data
  },
}


